import { render, staticRenderFns } from "./VxSidebar.vue?vue&type=template&id=3595d934&"
import script from "./VxSidebar.vue?vue&type=script&lang=js&"
export * from "./VxSidebar.vue?vue&type=script&lang=js&"
import style0 from "./VxSidebar.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3595d934')) {
      api.createRecord('3595d934', component.options)
    } else {
      api.reload('3595d934', component.options)
    }
    module.hot.accept("./VxSidebar.vue?vue&type=template&id=3595d934&", function () {
      api.rerender('3595d934', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layouts/components/vx-sidebar/VxSidebar.vue"
export default component.exports